 <template>
	<v-container class="noMargin">	    
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>COST MATRIX</h2>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque a nulla mauris. Vestibulum augue enim, aliquam eget mi sit amet, mattis tempus risus. Vivamus blandit pretium lorem eu placerat. Aenean tincidunt lobortis massa, non viverra nibh volutpat ac. Maecenas sed bibendum neque. Cras et nisl tortor.</p>
				</div>	
                <v-btn @click.prevent="fncRadiusStructure" class="elevation-5" color="info"><i class="material-icons">edit</i>Edit Radius Structure</v-btn>				
                <v-btn @click.prevent="fncAddMatrix" class="elevation-5" color="info"><i class="material-icons">add</i>Add</v-btn>				
				<v-btn @click.prevent="fncSaveMatrix" class="elevation-5" color="info"><i class="material-icons">add</i>Save</v-btn>				
				<v-btn @click.prevent="fncReloadMatrix" class="elevation-5" color="info"><i class="material-icons">refresh</i>Reload</v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
            fncSaveMatrix() {				
              this.$store.dispatch('fncSaveMatrix')
          },
          fncRadiusStructure() {
              var modalDetails = { title: 'Edit Radius Structure', component: 'modal-edit-radius', mstate: true, params: {} };			
			  this.$store.commit({
				  type: 'setModal',
				  details: modalDetails
			  });
            },
          fncAddMatrix() {
            this.$store.commit('fncAddMatrix');
          },
          fncReloadMatrix() {
            this.$store.commit('fncEmptyMatrix');
            this.$store.dispatch({
              type: 'fncPopulateMatrix',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>